export const environment = {
  allowImageExt: '.jpg,.png,.jpeg',
  dockerCompose: false,
  featureFlags: { longPolling: true },
  firebaseConfig: {
    apiKey: 'AIzaSyACtk4nQIkvs91acKg5B9b0V3y4qW8tVGM',
    appId: '1:871100133386:web:ceda850f6d2bab12a5eff3',
    authDomain: 'terrific-deploy.firebaseapp.com',
    measurementId: 'G-PPHLZ2C8SE',
    messagingSenderId: '871100133386',
    projectId: 'terrific-deploy',
    storageBucket: 'terrific-deploy.appspot.com',
  },
  maxUplodedImageSize: 5_000_001,
  platformServiceUrl: 'https://app-terrific-deploy-stage.terrific.live',
  production: true,
  terrificWebsiteUrl: 'https://staging.terrific.live',
  useEmulators: false,
};
